import devCustom from './components/devCustom.vue';
export default {
  components: {
    devCustom: devCustom
  },
  data: function data() {
    return {
      //渠道配置
      formId: 137
    };
  },
  methods: {}
};